
import { Component, Input, OnInit } from '@angular/core';
import { PluginContextService } from '../../../core/services/plugin-context.service';
import { ApiService } from '../../../core/services/api.service';
import { ConfigurationManagerService } from '../../../core/services/configuration-manager.service';

@Component({
  selector: 'app-single-attachment-attribute-visualizer',
  standalone: true,
  imports: [],
  templateUrl: './single-attachment-attribute-visualizer.component.html',
  styleUrl: './single-attachment-attribute-visualizer.component.css'
})
export class SingleAttachmentAttributeVisualizerComponent implements OnInit {
  @Input() mapentityid: string = '';
  @Input() type: string = '';
  @Input() attachmentData: string = ''; // Changed from attachmentUrl to attachmentData

  entity: any;
  attachmentId: string = '';
  attachmentName: string = '';
  attachmentUrl: string = '';
 collapsed: boolean = true;
  constructor(
    private pluginContext: PluginContextService,
    private api: ApiService
  ) { }

  ngOnInit(): void {
    if (this.mapentityid) {
      const entity = this.pluginContext.getDataContext().getMapEntity(this.mapentityid);
      const arcLiveEntity = entity?.arcLiveMapEntity;
      
      if (arcLiveEntity?.attachments?.[0]) {
        const attachment = arcLiveEntity.attachments[0];
        this.entity = arcLiveEntity;
        this.parseAttachment(attachment);
        this.retrieveAttachmentUrl(this.attachmentId);
      }
    } else if (this.attachmentData) {
      // Handle direct attachment data
      this.parseAttachment(this.attachmentData);
      this.retrieveAttachmentUrl(this.attachmentId);
    }
  }

  private parseAttachment(attachment: string): void {
    this.attachmentId = attachment.replace(/^(\d+)\..*$/, '$1');
    this.attachmentName = attachment.replace(/^\d+\.(.*)$/, '$1');
  }

retrieveAttachmentUrl(attachmentId: string): void {
  if (!attachmentId) return;

  const baseUrl = ConfigurationManagerService.settings.BaseURL;

  this.api.postBlob(`${baseUrl}db/IncidentUpdateAttachment/${attachmentId}/fileFromOrganization`, {
    attachment: false
  }).subscribe({
    next: (result: any) => {
      const blob = result.body; // The body is already a blob

      if (this.isVideo(this.attachmentName)) {
        this.attachmentUrl = URL.createObjectURL(blob);
      } else {
        const reader = new FileReader();
        reader.addEventListener('load', () => {
          this.attachmentUrl = reader.result as string;
        });
        reader.readAsDataURL(blob);
      }
    },
    error: (error) => {
      if (error.status === 201 && error.error instanceof Blob) {
        const blob = error.error;
        
        if (this.isVideo(this.attachmentName)) {
          this.attachmentUrl = URL.createObjectURL(blob);
        } else {
          const reader = new FileReader();
          reader.addEventListener('load', () => {
            this.attachmentUrl = reader.result as string;
          });
          reader.readAsDataURL(blob);
        }
      } else {
        console.error('Error retrieving attachment:', error);
      }
    }
  });
}

  isVideo(name: string): boolean {
    if (!name) return false;
    const ext = this.getExtension(name);
    return ['m4v', 'avi', 'mpg', 'mp4'].includes(ext.toLowerCase());
  }

  isImage(name: string): boolean {
    if (!name) return false;
    const ext = this.getExtension(name);
    return ['jpg', 'jpeg', 'gif', 'bmp', 'png'].includes(ext.toLowerCase());
  }

  private getExtension(filename: string): string {
    const parts = filename.split('.');
    return parts.length > 1 ? parts[parts.length - 1] : '';
  }

  ngOnDestroy(): void {
    if (this.attachmentUrl && this.attachmentUrl.startsWith('blob:')) {
      URL.revokeObjectURL(this.attachmentUrl);
    }
  }
}